module.exports = __webpack_public_path__ + "img/pic_suppay_appstore_black@3x.c208be30.png";